import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const offers = [
  {
    code: "ALMOUNE10",
    title: "10 EUR offerts",
    description: "Remise de 10 EUR sur une commande de 79 EUR ou plus.",
  },
  {
    code: "LIVRAISON49",
    title: "Livraison standard offerte",
    description: "La livraison devient gratuite des 49 EUR sur les commandes eligibles.",
  },
  {
    code: "DOUCEURS5",
    title: "5% sur les gourmandises",
    description: "Une offre dediee aux douceurs orientales et produits de fete selon disponibilite.",
  },
];

const Coupons = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [selectedCode, setSelectedCode] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {loaderStatus ? (
        <div className="loader-container">
          <MagnifyingGlass
            visible={true}
            height="100"
            width="100"
            ariaLabel="magnifying-glass-loading"
            wrapperStyle={{}}
            wrapperclassName="magnifying-glass-wrapper"
            glassColor="#c0efff"
            color="#0aad0a"
          />
        </div>
      ) : (
        <>
          <ScrollToTop />
          <section className="my-lg-14 my-8">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-9 text-center mb-8">
                  <h1 className="fw-bold">Promotions Almoune</h1>
                  <p className="lead mb-0">
                    Retrouvez ici les offres mises en avant pour vos commandes en ligne.
                  </p>
                </div>
              </div>

              <div className="row g-4">
                {offers.map((offer) => (
                  <div className="col-lg-4 col-md-6" key={offer.code}>
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body p-5 d-flex flex-column">
                        <span className="badge bg-success-subtle text-success border border-success-subtle mb-3">
                          {offer.code}
                        </span>
                        <h4 className="mb-3">{offer.title}</h4>
                        <p className="text-muted mb-4">{offer.description}</p>
                        <button
                          type="button"
                          className={`btn mt-auto ${selectedCode === offer.code ? "btn-dark" : "btn-outline-primary"}`}
                          onClick={() => setSelectedCode(offer.code)}
                        >
                          {selectedCode === offer.code ? "Code selectionne" : "Afficher ce code"}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="card border-0 shadow-sm mt-6">
                <div className="card-body p-5 text-center">
                  <h5 className="mb-2">Les promotions peuvent varier selon la periode et les stocks.</h5>
                  <p className="text-muted mb-4">
                    Verifiez votre panier ou contactez la boutique pour connaitre les offres actuellement mises en avant.
                  </p>
                  <Link to="/Shop" className="btn btn-primary">
                    Voir la boutique
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default Coupons;
